<template lang="html">
  <div class="telehealth">
    <div class="content telehealth-content" ref="telehealthContent">
      <div class="telehealth-form main-content-cj h-100 mh-100">
        <b-container class="d-flex flex-column h-100 mh-100">
          <div class="box-container">
            <b-form-row>
              <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
                <div class="box-cj mb-3">
                  <div class="content">
                    <b-row v-if="telehealthAppointment != null">
                      <b-col cols="12" lg="6" class="d-flex flex-column justify-content-center mb-3 mb-lg-0">
                        <h4 class="font-lighter mb-0">{{telehealthAppointment.appointment_type.type}} com {{telehealthAppointment.professional.name}}</h4>
                      </b-col>
                      <b-col class="d-flex flex-column justify-content-center text-lg-right">
                        <p class="mb-1">Paciente: {{telehealthAppointment.patient.name}}<i class="far fa-user ml-2"></i></p>
                        <p class="mb-0">Início: {{moment(telehealthAppointment.start_datetime).format('HH:mm')}}<i class="far fa-clock ml-2"></i></p>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>

              <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
                <div class="box-cj mb-0">
                  <div id="attendance_content" class="content p-0 d-flex justify-content-center align-items-center">
                    <div v-if="telehealthAttendance != null && (telehealthAttendance.start_datetime == null || !telehealthAttendance.patient_entered)" class="text-center">
                      <div v-if="!telehealthAttendance.patient_entered" class="mb-3 patient-status-text">O paciente ainda não entrou.</div>
                      <div v-else class="mb-3 patient-status-text"><i class="far fa-clock text-primary mr-2"></i>Aguardando {{telehealthAppointment.professional.name}}.</div>
                    </div>
<!--                    https://github.com/AgoraIO-Community/VideoUIKit-Web-React/blob/main/web-component/README.md -->
                    <agora-react-web-uikit
                        v-else-if="telehealthAttendance != null && telehealthAttendance.start_datetime != null && telehealthAttendance.end_datetime == null"
                        class="agora-uikit-cj"
                        :appId="agoraId"
                        :channel="telehealthAttendance.id"
                        :token="agoraToken"
                        :uid="user.person.id"
                        :username="user.person.name"
                        displayUsername="true" />
                    <div v-else-if="telehealthAttendance != null && telehealthAttendance.end_datetime != null" class="text-center">
                      <div class="mb-3">Teleconsulta finalizada.</div>
                      <router-link tag="a" class="btn btn-block btn-primary" :to="'/'">Sair</router-link>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-form-row>
          </div>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
// import {compressToUTF16, decompressFromUTF16} from "lz-string";

  export default {
    data() {
      return {
        leavingPage: false,

        isMobile: false,
        agoraId: process.env.VUE_APP_AGORA_ID,
        agoraToken: '',

        telehealthCheckInterval: null,
        telehealthLayoutInterval: null,
        attachedTelehealthEventListener: false,

        user: null,

        termSingular: '',
        url: '',
        module: '',

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canManage: true,
        canPerformAction: true,


        telehealthAppointment: null,
        telehealthAttendance: null
      }
    },
    async mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));

      this.termSingular = 'paciente';
      this.url = 'pacientes';
      this.module = 'patients';

      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_remove');
      this.canManage = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_manage');

      if(this.canSee == false || this.user.person.type != 'PROFESSIONAL' || !this.helpers.planHasPermission('telehealth') || !this.user.person.client.enable_multi_professional_telehealth_attendance) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      this.canPerformAction = false;

      document.addEventListener('focusin', function (e) {
        let closest = e.target.closest('.swal2-input');
        if (closest !== null && closest !== undefined) {
          e.stopImmediatePropagation();
        }
      });

      await this.api.getSpectateTelehealthAppointmentData(this.$route.params.patientId, this.$route.params.id).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.canPerformAction = true;
        this.eventBus.$emit('IS_LOADING', false);

        this.agoraToken = res.data.agora_token;
        this.telehealthAppointment = res.data.telehealth_appointment;
        this.telehealthAttendance = res.data.telehealth_attendance;

        if(this.telehealthAttendance.start_datetime == null || this.telehealthAttendance.end_datetime == null) {
          this.telehealthCheckInterval = setInterval(this.checkTelehealthAttendance, 25*1000);
          this.telehealthLayoutInterval = setInterval(this.ajustTelehealthLayout, 3*1000);
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Spectate Telehealth Appointment Data', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.canPerformAction = true;
        this.eventBus.$emit('IS_LOADING', false);

        let msg = 'Não conseguimos carregar este atendimento de teleconsulta! Por favor, entre em contato com o suporte!';
        switch (err.response.status) {
          case 400:
            msg = err.response.data.message;
            break;
        }
        this.$swal('Ops...', msg, 'error');
        this.$router.push({path: '/' + this.url + '/' + this.$route.params.patientId}).catch(() => {});

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Spectate Telehealth Appointment Data', err.response);
      });

      this.attachAgoraEndCallEventListener();
    },
    methods: {
      async attachAgoraEndCallEventListener() {
        if(this.attachedTelehealthEventListener) {
          return;
        }
        setTimeout(() => {
          let element = document.querySelector('agora-react-web-uikit');
          if(!element) {
            return;
          }
          element.addEventListener('agoraUIKitEndcall', (event) => {
            this.endTelehealthAttendance();
          });
          this.attachedTelehealthEventListener = true;
        }, 50);
      },

      async checkTelehealthAttendance() {
        await this.api.checkTelehealthAttendance(this.$route.params.patientId, this.telehealthAttendance.id).then(res => {
          if(this.leavingPage) {
            return;
          }
          this.telehealthAttendance = res.data;

          if(this.telehealthAttendance.end_datetime != null) {
            clearInterval(this.telehealthCheckInterval)
            this.telehealthCheckInterval = null;
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Check Telehealth Attendance', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          let msg = 'Não conseguimos carregar este atendimento de teleconsulta! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
          switch (err.response.status) {
            case 400:
              msg = err.response.data.message;
              break;
          }
          if(msg === 'Este atendimento já foi encerrado!') {
            if(this.telehealthAttendance.end_datetime == null) {
              this.telehealthAttendance.end_datetime = 1;
            }
            else {
              msg = null;
            }
          }
          if(msg) {
            this.$swal('Ops...', msg, 'error');
          }

          clearInterval(this.telehealthCheckInterval)
          this.telehealthCheckInterval = null;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Check Telehealth Attendance', err);
        });
      },

      ajustTelehealthLayout() {
        if(this.telehealthAttendance.start_datetime == null) {
          return;
        }
        if(this.telehealthAttendance.end_datetime != null) {
          clearInterval(this.telehealthLayoutInterval)
          this.telehealthLayoutInterval = null;
        }
        let agoraUiKit = document.querySelector('.agora-uikit-cj');
        if(!agoraUiKit || !agoraUiKit.shadowRoot) {
          return;
        }
        let patientVideo = agoraUiKit.shadowRoot.querySelector('div[id^="agora-video-player-track-video-' + this.telehealthAppointment.patient.id + '-client"]'),
            professionalVideo = agoraUiKit.shadowRoot.querySelector('div[id^="agora-video-player-track-video-' + this.telehealthAppointment.professional.id + '-client"]');

        if(patientVideo && !patientVideo.classList.contains('cj-custom-layout')) {
          patientVideo.classList.add('cj-custom-layout');
          try {
            patientVideo.parentElement.parentElement.parentElement.style.order = -10;
          } catch(err) {
            console.log(err);
          }
        }
        if(professionalVideo && !professionalVideo.classList.contains('cj-custom-layout')) {
          professionalVideo.classList.add('cj-custom-layout');
          try {
            professionalVideo.parentElement.parentElement.parentElement.style.order = -5;
          } catch(err) {
            console.log(err);
          }
        }
      },

      async endTelehealthAttendance() {
        if(!this.canPerformAction)
          return false;

        this.$swal({
          title: 'Sair da chamada',
          text: 'Tem certeza que deseja sair desta chamada de teleconsulta?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sair da chamada',
          cancelButtonText: 'Cancelar',
          focusConfirm: true
        }).then((res) => {
          if(res.value) {
            this.telehealthAttendance.end_datetime = 1;
            this.$router.push({ path: '/' }).catch(() => {});
          }
        });
      },
    },

    beforeDestroy() {
      if(this.telehealthLayoutInterval != null) {
        clearInterval(this.telehealthLayoutInterval);
      }
      if(this.telehealthCheckInterval != null) {
        clearInterval(this.telehealthCheckInterval);
      }
    },

    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .telehealth {
    display: flex;
    overflow: hidden;
    min-height: 100vh;

    .telehealth-content {
      flex: 1;
      background-color: #f0f2f8;
      height: 100vh;
      overflow: scroll;
      overflow-x: hidden;
    }
  }

  @media (max-width: 767px) {
    .telehealth {
      flex-flow: column wrap;
    }

    //.telehealth-content {
    //  margin-top: 86px;
    //  height: calc(100vh - 86px) !important;
    //}
  }


  .telehealth-form {
    padding: 14px 0;
  }

  .patient-status-text {
    font-size: 18px;
  }

  #attendance_content {
    height: 945px;
  }
  .agora-uikit-cj {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .text1 {
    font-size: 15px;
    color: $cadetGray;
    margin-bottom: 0;
  }
  @media (max-height: 1100px) {
    #attendance_content {
      height: calc(100vh - 180px)!important;
    }
  }
  @media (max-height: 991px) {
    #attendance_content {
      min-height: 450px;
    }
  }
</style>
